/* eslint-disable react-refresh/only-export-components */
import React, { useState, useContext, useEffect } from "react";
import toast from "react-hot-toast";

import { WishlistContext } from "./Contexts";

export { WishlistContext };

export function WishlistProvider({ children }) {
  const [wishlist, setWishlist] = useState(() => {
    const savedWishlist = localStorage.getItem("neotec_wishlist");
    if (savedWishlist) {
      try {
        return JSON.parse(savedWishlist);
      } catch (e) {
        console.error("Error parsing wishlist:", e);
      }
    }
    return [];
  });

  // Save to localStorage whenever wishlist changes
  useEffect(() => {
    localStorage.setItem("neotec_wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  function addToWishlist(product) {
    if (isInWishlist(product.id)) {
      removeFromWishlist(product.id);
      return;
    }
    setWishlist([...wishlist, product]);
    toast.success("Agregado a lista de deseos");
  }

  function removeFromWishlist(productId) {
    setWishlist(wishlist.filter((item) => item.id !== productId));
    toast.success("Eliminado de lista de deseos");
  }

  function isInWishlist(productId) {
    return wishlist.some((item) => item.id === productId);
  }

  const [isWishlistOpen, setIsWishlistOpen] = useState(false);

  function toggleWishlist() {
    setIsWishlistOpen(!isWishlistOpen);
  }

  function clearWishlist() {
    setWishlist([]);
  }

  return (
    <WishlistContext.Provider
      value={{
        wishlist,
        addToWishlist,
        removeFromWishlist,
        isInWishlist,
        clearWishlist,
        isWishlistOpen,
        toggleWishlist,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  return useContext(WishlistContext);
}
